import { FloorsIndexResponse } from "app/services/api/types/locations/responses/FloorsIndexResponse";
import { Text, View } from "react-native";

interface FilterSummaryProps {
  floors: FloorsIndexResponse;
  selectedFloorIds: number[];
  selectedRoomIds: number[];
  unassignedSelected: boolean;
}

export function FilterSummary({
  floors,
  selectedFloorIds,
  selectedRoomIds,
  unassignedSelected,
}: FilterSummaryProps) {
  function formatRoomRange(rooms: string[]): string {
    if (rooms.length === 0) return "";

    const result: string[] = [];
    let start = rooms[0];
    let end = rooms[0];

    const pushRange = () => {
      if (start === end) result.push(start);
      else result.push(`${start}-${end}`);
    };

    for (let i = 1; i < rooms.length; i++) {
      const curr = rooms[i];
      const prevNum = parseInt(end, 10);
      const currNum = parseInt(curr, 10);

      if (currNum === prevNum + 1) {
        end = curr;
      } else {
        pushRange();
        start = end = curr;
      }
    }

    pushRange();
    return result.join(", ");
  }

  if (unassignedSelected) {
    return (
      <View className="flex-row gap-x-1">
        <Text className="text-typography-500 font-medium">
          Showing items for
        </Text>
        <Text>Unassigned</Text>
      </View>
    );
  }

  const selectedSummary = floors
    .filter(
      (floor) =>
        selectedFloorIds.includes(floor.id) ||
        floor.rooms.some((r) => selectedRoomIds.includes(r.id)),
    )
    .map((floor) => {
      const roomNumbers = floor.rooms
        .filter((r) => selectedRoomIds.includes(r.id))
        .map((r) => r.room_number)
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

      const roomPart = roomNumbers.length
        ? ` (Rm. ${formatRoomRange(roomNumbers)})`
        : "";

      return `Fl. ${floor.floor_number}${roomPart}`;
    })
    .join(" | ");

  return (
    <View className="flex-row gap-x-1 sm:max-w-96 flex-1 justify-end">
      <Text className="text-typography-500 font-medium">Showing items for</Text>
      <Text>{selectedSummary || "All Floors & Rooms"}</Text>
    </View>
  );
}
